import React, { useState, useEffect, useRef, Fragment } from 'react';
import {
    TabContent, TabPane, Nav, NavItem, NavLink, Row, Button, FormGroup, Label, Input, Alert, Modal, ModalHeader,
    ModalBody, ModalFooter, InputGroup, InputGroupAddon, InputGroupText
} from 'reactstrap';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import '../estilos.css';
import * as IoIcons from 'react-icons/io';
import Pagination from "react-js-pagination";
import Moment from 'moment';
//import { API } from 'aws-amplify';
import { listEmbarqueUltimoNumeros } from '../../graphql/queries';
import {
    updateFacturaConceptoGeneral,
    createFacturaConceptoGeneral,
    createEmbarqueUltimoNumero,
    updateEmbarqueUltimoNumero
} from '../../graphql/mutations';
import { useReactToPrint } from 'react-to-print';
import {
    GetClientes, GetFacturaConceptoGeneral, GetFacturaConceptoGeneralID,
    GetUsuarios
} from '../queries/Queries';
import { ObtenerServiciosFacturacion } from '../queries/DCUbicaciones';
import { generateClient } from "aws-amplify/api";

const API = generateClient();

const initialfFormState = { formType: 'FacturaciónGeneral' }
function FacturacionG() {
    const [ultimoNumeroP, setultimoNumeroP] = useState(0);
    const [formState, updateFormState] = useState(initialfFormState);
    const [sumTotalServicio, setSumTotalServicio] = useState("");
    const [sumSubTotalServicio, setSumSubTotalServicio] = useState("");
    const [sumTotalDesServicio, setSumTotalDesServicio] = useState("");
    const [isDisabled, setisDisabled] = useState(false);
    const [buscarporFecha, setBuscarporFecha] = useState(true);
    const [search, setSearch] = useState("");
    const [fechaPBusqueda, setFechaPBusqueda] = useState("");
    const [searchBy, setSearchBy] = useState("cliente");
    const { formType } = formState;
    const [mensajeAlert, setMensajeAlert] = useState("No fue posible realizar la operación, error indeterminado: revise su conexión a internet, recargue la página y vuelva a intentarlo, si el error persiste, favor de comunicarse a sistemas");
    const [color, setColor] = useState("warning");
    const userName = window.$name;
    const vpreciounitario = window.$VerPrecioUnitario ? window.$VerPrecioUnitario : false;
    const [aVisible, setAVisible] = useState(false);
    const [cargando, setCargando] = useState(false);
    const onDismiss = () => setAVisible(false);


    /*Factura */
    const pfacturacion = window.$Facturacion ? window.$Facturacion : false;
    const serviciosIniciales = { quantity: 0, description: "", uprice: 0.0, subTotal: 0.0, discount: 0, total: 0.0, createdAt: "", updatedAt: "", Reg_Ins_Usuario: userName, Reg_Mod_Usuario: "" }
    const [facturasSinFiltro, setFacturasSinFiltro] = useState([]);
    const [facturados, setFacturados] = useState([]);
    const [usariosNC, setUsuariosNC] = useState([]);
    const [paginas, setPaginas] = useState([]);
    const [clientes, setClientes] = useState([]);
    const [datosIncompletos, setDatosIncompletos] = useState(false);
    const [inputListServicios, setInputListServicios] = useState([]);
    const [facturaEditando, setFacturaEditando] = useState({});
    const [clienteID, setClienteID] = useState("");
    const [cliente, setCliente] = useState("");
    const [fechaFactura, setFechaFactura] = useState("");
    const [requisitioner, setRequisitioner] = useState("");
    const [facturaDescuentoP, setFacturaDescuentoP] = useState("");
    const [poNumber, setPoNumber] = useState("");
    const [salesPerson, setSalesPerson] = useState("");
    const [comentariosFacturacion, setComentariosFacturacion] = useState("");
    const [dueDate, setDueDate] = useState("");
    const [casQuote, setCasQuote] = useState("");
    const [invoiceID, setInvoiceID] = useState("");
    const [shipTo, setShipTo] = useState("");
    const [billTo, setBillTo] = useState("");
    const [editar, setEditar] = useState(false);
    const aniosLetra = [
        { letra: "A", año: "2020", ar: "Y" },
        { letra: "B", año: "2021", ar: "Z" },
        { letra: "C", año: "2022", ar: "A" },
        { letra: "D", año: "2023", ar: "B" },
        { letra: "E", año: "2024", ar: "C" },
        { letra: "F", año: "2025", ar: "D" },
        { letra: "G", año: "2026", ar: "E" },
        { letra: "H", año: "2027", ar: "F" },
        { letra: "I", año: "2028", ar: "G" },
        { letra: "J", año: "2029", ar: "H" },
        { letra: "K", año: "2030", ar: "I" },
        { letra: "L", año: "2031", ar: "J" },
        { letra: "M", año: "2032", ar: "K" },
        { letra: "N", año: "2033", ar: "L" },
        { letra: "O", año: "2034", ar: "M" },
        { letra: "P", año: "2035", ar: "N" },
        { letra: "Q", año: "2036", ar: "O" },
        { letra: "R", año: "2037", ar: "P" },
        { letra: "S", año: "2038", ar: "Q" },
        { letra: "T", año: "2039", ar: "R" },
        { letra: "U", año: "2040", ar: "S" },
        { letra: "V", año: "2041", ar: "T" },
        { letra: "W", año: "2042", ar: "U" },
        { letra: "X", año: "2043", ar: "V" },
        { letra: "Y", año: "2043", ar: "W" },
        { letra: "Z", año: "2045", ar: "X" },
    ];

    const mesNumero = [
        { mes: "01", numero: "1" },
        { mes: "02", numero: "2" },
        { mes: "03", numero: "3" },
        { mes: "04", numero: "4" },
        { mes: "05", numero: "5" },
        { mes: "06", numero: "6" },
        { mes: "07", numero: "7" },
        { mes: "08", numero: "8" },
        { mes: "09", numero: "9" },
        { mes: "10", numero: "10" },
        { mes: "11", numero: "11" },
        { mes: "12", numero: "12" },
    ];
    //Datos de año
    const Anio = Moment(now).format("YYYY");
    const anioLetra = aniosLetra.filter((anio) => anio.año == Anio);
    const aLetra = anioLetra[0].letra ? anioLetra[0].letra : "NAN";
    const aLetrar = anioLetra[0].ar ? anioLetra[0].ar : "NAN";

    //Equivalente del mes en número.
    const lmes = Moment(new Date()).format("MM");
    var mNumero = "0";
    const mesesNumeros = mesNumero.filter((nmes) => nmes.mes === lmes);
    if (mesesNumeros[0]) mNumero = mesesNumeros[0].numero;

    Moment.locale('en');
    var now = new Date();
    var now2 = new Date();
    //now2.setMonth(now2.getMonth() - 1);
    now2.setDate(now2.getDate() - 1);
    now.setDate(now.getDate() + 5);
    const [rfechaini, setRfechaini] = useState(Moment(now2).format("YYYY-MM-DD"));
    const [rfechafin, setRfechafin] = useState(Moment(now).format("YYYY-MM-DD"));


    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    // current page
    const [currentPage, setCurrentPage] = useState(1);
    const [currentPageFacturacion, setCurrentPageFacturacion] = useState(1);

    // total records per page to display
    const recordPerPage = 20;

    // range of pages in paginator
    const pageRange = 5;

    // handle change event
    function handlePageChangeFacturacion(pageNumber) {
        window.scrollTo(0, 0);
        setCargando(true);
        setAVisible(false);
        setCurrentPageFacturacion(pageNumber);
        busqueFactura(
            facturasSinFiltro,
            searchBy,
            search,
            pageNumber
        );
    }

    //Método useEffect
    useEffect(() => {
        fetchClientes();
        fetchFacturas(rfechaini, rfechafin);
        fetchUsuario();
    }, []);

    //Obtiene los datos guardados de las facturas
    async function fetchFacturas(fechainicial, fechafinal) {
        //Filtro por factura activo y fecha
        setCargando(true);
        let filter = {
            and: [
                {
                    activo: {
                        eq: true,
                    },
                },
                {
                    fechaDeFacturacion: {
                        ge: fechainicial,
                    },
                },
                {
                    fechaDeFacturacion: {
                        le: fechafinal,
                    },
                },
            ],
        };
        const apiData = await GetFacturaConceptoGeneral(filter);
        const FacturaGFromAPI = apiData.sort((a, b) =>
            a.numero < b.numero ? 1 : a.numero > b.numero ? -1 : 0
        );

        if (FacturaGFromAPI.length > 0) {
            setFacturasSinFiltro(FacturaGFromAPI);
            busqueFactura(
                FacturaGFromAPI,
                searchBy,
                search,
                currentPage
            );
        } else {
            setFacturados([]);
        }
        setCargando(false);
    }

    //Obtiene los usuarios activos con permisos para autorizar no usar FIFO en planeación.
    async function fetchUsuario() {
        //Filtro por usuarios activos        
        let filter = {
            activo: {
                eq: true
            }
        }
        //Se obtienen los datos de los usuarios
        const apiData = await GetUsuarios(filter);
        //Se ordenan los datos por el campo orden
        const dataFromAPI = apiData.sort((a, b) =>
            a.orden > b.orden ? 1 : a.orden < b.orden ? -1 : 0);
        const usuarioLG = dataFromAPI.filter(usuarios => usuarios.usuario === userName);
        setUsuariosNC(usuarioLG[0] ? usuarioLG[0].nombreCompleto : "");
    }

    function onSearchFechaFacturaGEN(e) {
        setAVisible(false);
        window.scrollTo(0, 0);
        setCargando(true);
        setFechaPBusqueda(e.target.value);
        // busquedaPlaneacion(planeacionSinFiltro, currentPageFacturacion, e.target.value, vistaNumeroParte, verSeguimiento);
        fetchFacturas(e.target.value, e.target.value);
    };


    function clicBuscarporFecha(e) {
        setAVisible(false);
        setBuscarporFecha(!buscarporFecha);
        if (!buscarporFecha === false) {
            if (fechaPBusqueda !== "") {
                setFechaPBusqueda("");
                fetchFacturas(rfechaini, rfechafin);
            }
        }
    };
    // handle click event of the Remove button
    function handleRemoveClick(index, list) {
        list.splice(index, 1);
        return list;
    }
    //Revisa cambios en la fecha de búsqueda
    function onChangesRFechaFGEN(e) {
        e.persist()
        var fechaini = rfechaini;
        var fechafin = rfechafin;
        if (e.target.name === "Irfechaini") {
            fechaini = e.target.value;
        } else {
            fechafin = e.target.value;
        }
        setRfechafin(fechafin);
        setRfechaini(fechaini);
        fetchFacturas(fechaini, fechafin);
    }
    //Obtiene los datos guardados de los clientes
    async function fetchClientes() {

        //Filtro por cliente activo
        let filter = {
            activo: {
                eq: true
            }
        }

        //Se obtienen los datos de los clientes
        const apiData = await GetClientes(filter);

        setClientes(apiData);
    }

    async function busqueFactura(facturag, searchb, search, currentPage) {
        var i = 1;
        var paginasp = [];
        var p = 1;
        var pi = 1;
        var racks = 0;

        const dataFromAPI = facturag
            .sort((a, b) =>
                a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0
            )
            .filter((facturagen) =>
                searchb === "numero de parte"
                    ? facturagen.numerosdeParte.toLowerCase().includes(search.toLowerCase())
                    : searchb === "cliente"
                        ? facturagen.cliente.toLowerCase().includes(search.toLowerCase())
                        : searchb === "invoiceid"
                            ? facturagen.invoiceID.toLowerCase().includes(search.toLowerCase())
                            : searchb === "serial"
                                ? facturagen.seriales.toLowerCase().includes(search.toLowerCase())
                                : searchb === "paking"
                                    ? facturagen.packings.toLowerCase().includes(search.toLowerCase())
                                    : searchb === "lote"
                                        ? facturagen.lotes.toLowerCase().includes(search.toLowerCase())
                                        : Moment(facturagen.fechaDeFacturacion)
                                            .format("DD/MM/YYYY")
                                            .includes(Moment(search).format("DD/MM/YYYY"))
            );

        await Promise.all(
            dataFromAPI.map(async (facturagenp) => {
                facturagenp.paginacion = pi;
                p++;
                if (p > recordPerPage) {
                    p = 1;
                    paginasp.push({ pagina: pi });
                    pi++;
                }
                return facturagenp;
            })
        );

        const lengthFacturagen = dataFromAPI.length;
        if (lengthFacturagen <= 0) setCurrentPage(1);

        const facturasgen = dataFromAPI
            .filter((facturagenp) => facturagenp.paginacion === currentPage)
            .sort((a, b) =>
                a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0
            );
        if (facturasgen.length) {
            setFacturados(facturasgen);
        }

        //setTotalRecordsEmbarque(lengthFacturagen);
        const prepaginas = parseInt(lengthFacturagen / recordPerPage);
        const paginas =
            prepaginas * recordPerPage < lengthFacturagen
                ? prepaginas + 1
                : prepaginas;
        if (paginas > paginasp.length) paginasp.push({ pagina: paginas });

        if (currentPage > 1 && lengthFacturagen > 0) {
            if (currentPage > paginas) {
                setCurrentPage(paginas);
            }
        }

        if (lengthFacturagen > 0) {
            setPaginas(paginasp);
            setultimoNumeroP(paginasp[paginasp.length - 1].pagina);
        } else {
            setPaginas([]);
            setultimoNumeroP(0);
        }
    }

    function clicNuevaFacturaGEN() {
        setAVisible(false);
        setDatosIncompletos(false);
        setFacturaEditando({});
        setInputListServicios([]);
        setFechaFactura("");
        setRequisitioner("");
        setFacturaDescuentoP("");
        setSalesPerson("");
        setComentariosFacturacion("");
        setDueDate("");
        setShipTo("");
        setBillTo("");
        setCliente("");
        setClienteID("");
        setPoNumber("");
        setInvoiceID("");
        setEditar(false);

        updateFormState(() => ({ ...formState, formType: "EditarFG" }));
    };

    async function clicEditar(factura) {
        setCargando(true);
        setAVisible(false);
        //Si existen registros  
        const servicios = (factura.Conceptos ? factura.Conceptos : []).length > 0 ? await ObtenerServiciosFacturacion(factura.Conceptos) : [];
        setFacturaEditando(factura);
        setDatosIncompletos(false);
        setInputListServicios(servicios.servicios ? servicios.servicios : []);
        setFechaFactura(factura.fechaDeFacturacion);
        setRequisitioner(factura.requisitioner);
        setFacturaDescuentoP(factura.facturaDescuentoP);
        setSalesPerson(factura.salesPerson);
        setComentariosFacturacion(factura.comentariosFacturacion);
        setDueDate(factura.dueDate);
        setShipTo(factura.shipTo);
        setBillTo(factura.billTo);
        setCliente(factura.cliente);
        setClienteID(factura.clienteID);
        setPoNumber(factura.PO);
        setInvoiceID(factura.invoiceID);
        setEditar(true);
        updateFormState(() => ({ ...formState, formType: "EditarFG" }));
        setCargando(false);
    };

    async function clicMostrar(factura) {
        setCargando(true);
        setAVisible(false);
        setDatosIncompletos(false);
        //Si existen registros  
        const servicios = (factura.Conceptos ? factura.Conceptos : []).length > 0 ? await ObtenerServiciosFacturacion(factura.Conceptos) : [];
        setFacturaEditando(factura);
        setInputListServicios(servicios.servicios ? servicios.servicios : []);
        setFechaFactura(factura.fechaDeFacturacion);
        setRequisitioner(factura.requisitioner);
        setFacturaDescuentoP(factura.facturaDescuentoP);
        setSalesPerson(factura.salesPerson);
        setComentariosFacturacion(factura.comentariosFacturacion);
        setDueDate(factura.dueDate);
        setShipTo(factura.shipTo);
        setBillTo(factura.billTo);
        setCliente(factura.cliente);
        setClienteID(factura.clienteID);
        setPoNumber(factura.PO);
        setInvoiceID(factura.invoiceID);
        setEditar(true);
        updateFormState(() => ({ ...formState, formType: "DetalleFG" }));
        setCargando(false);
    };

    async function clicImprimir(factura) {
        setCargando(true);
        //Si existen registros  
        const servicios = (factura.Conceptos ? factura.Conceptos : []).length > 0 ? await ObtenerServiciosFacturacion(factura.Conceptos) : [];
        setFacturaEditando(factura);
        setDatosIncompletos(false);
        setInputListServicios(servicios.servicios ? servicios.servicios : []);
        setSumTotalServicio(servicios.total);
        setSumSubTotalServicio(servicios.subTotal);
        setSumTotalDesServicio(servicios.discounTotal);
        setFechaFactura(factura.fechaDeFacturacion);
        setRequisitioner(factura.requisitioner);
        setFacturaDescuentoP(factura.facturaDescuentoP);
        setSalesPerson(factura.salesPerson);
        setComentariosFacturacion(factura.comentariosFacturacion);
        setDueDate(factura.dueDate);
        setShipTo(factura.shipTo);
        setBillTo(factura.billTo);
        setCliente(factura.cliente);
        setClienteID(factura.clienteID);
        setPoNumber(factura.PO);
        setInvoiceID(factura.invoiceID);
        setEditar(false);
        setCargando(false);
        handlePrint();
    };

    // handle click event of the Add button
    function handleAddClick(list, datos) {
        list.push(datos)
        return list;
    }

    //Revisa cambios en el input de clientes
    function onChangesDatosFactura(e) {
        if (e.target.name === "fechaFactura") {
            setFechaFactura(e.target.value);
        }
        if (e.target.name === "requisitioner") {
            setRequisitioner(e.target.value)
        }
        if (e.target.name === "facturaDescuentoP") {
            setFacturaDescuentoP(e.target.value);
        }
        if (e.target.name === "poNumber") {
            setPoNumber(e.target.value)
        }
        if (e.target.name === "salesPerson") {
            setSalesPerson(e.target.value)
        }
        if (e.target.name === "comentariosFacturacion") {
            setComentariosFacturacion(e.target.value)
        }
        if (e.target.name === "dueDate") {
            setDueDate(e.target.value)
        }

        // cambioDatosEmbarque(e);
    }

    //Revisa cambios en el input de clientes
    function onChangesClientes(e) {
        e.persist();
        const ocClienteID = e.target.value;
        if (e.target.value != "") {
            const fClientes = clientes.filter(
                (fcliente) => fcliente.id === ocClienteID
            );
            setClienteID(fClientes[0].id);
            setCliente(fClientes[0].cliente);
            setBillTo(fClientes[0].billTo);
            setShipTo(fClientes[0].shipTo);
        } else {
            setClienteID("");
            setCliente();
            setBillTo("");
            setShipTo("");
        }
    }

    function handleInputChangeServicios(e, index, list) {
        const { name, value } = e.target;
        const re = /^[0-9\.]+$/;
        if (name === "description") {
            list[index][name] = value;
        } else {
            if (e.target.value === '' || re.test(e.target.value)) {
                list[index][name] = value;
            }
            const totalP = ((list[index].uprice * list[index].quantity)).toFixed(2);
            const descuento = facturaDescuentoP ? ((totalP * facturaDescuentoP) / 100) : 0;
            list[index].subTotal = totalP;
            list[index].total = (totalP - descuento);
            list[index].discount = descuento;


        }
        list[index].Reg_Mod_Usuario = userName;
        list[index].updatedAt = new Date();
        return list;
    }

    function handleInputChangePD(e, list) {
        const re = /^[0-9\.]+$/;
        if (e.target.value === '' || re.test(e.target.value)) {
            setFacturaDescuentoP(e.target.value);
            list.map((embarques, i) => {
                if (
                    (embarques.uprice)) {
                    const totalP = ((embarques.uprice * embarques.quantity)).toFixed(2);
                    const descuento = e.target.value ? ((totalP * e.target.value) / 100) : 0;
                    embarques.subTotal = totalP;
                    embarques.total = (totalP - descuento);
                    embarques.discount = descuento;
                }
            });
        }
        return list;
    }

    function cancelarFactura() {
        setAVisible(false);
        setFacturaEditando({});
        setInputListServicios([]);
        setFechaFactura("");
        setRequisitioner("");
        setFacturaDescuentoP("");
        setSalesPerson("");
        setComentariosFacturacion("");
        setDueDate("");
        setShipTo("");
        setBillTo("");
        setCliente("");
        setClienteID("");
        setPoNumber("");
        setInvoiceID("");
        updateFormState(() => ({ ...formState, formType: "FacturaciónGeneral" }));
        fetchFacturas(rfechaini, rfechafin);
    }
    function revisarDatosCompletosServicios(list) {
        var datosCompletos = true;
        list.map((servicios) => {
            if (
                (!servicios.quantity || !servicios.description || !servicios.uprice || !servicios.total)) {
                datosCompletos = false;
            }
        });
        return datosCompletos;
    }
    async function manageFacturacion() {
        setAVisible(false);
        setCargando(true);
        setisDisabled(true);
        try {
            setMensajeAlert("Revisando cambios");
            //const ILCambios = inputList.filter(facturacionGen => facturacionGen.modificado === true);
            //setMensajeAlert("Cambios revisados" + JSON.stringify(ILCambios));
            //if (ILCambios[0]) {
            setMensajeAlert("Sí hay cambios");
            const datosCompletosServicios = await revisarDatosCompletosServicios(inputListServicios);
            setMensajeAlert("Datos revisados");
            var mensaje = "";
            if (!fechaFactura || !requisitioner || !poNumber || !salesPerson || !dueDate
                || !shipTo || !billTo || !clienteID || datosCompletosServicios === false) {
                mensaje = "Faltan datos; los campos marcados con un asterísco son obligatorios." +
                    "Datos seviciosCompletos:" + datosCompletosServicios + " Fecha: " + fechaFactura + " requi: " + requisitioner +
                    " po: " + poNumber + " salesp: " + salesPerson + " dueD: " + dueDate + " ship: " + shipTo + " bill: " + billTo +
                    " cliente: " + cliente + " DatosCompleto: " + datosCompletosServicios + " ClienteID: " + clienteID;
                setDatosIncompletos(true);
                setMensajeAlert(mensaje);
            }

            setMensajeAlert("Revisando mensajes");
            if (mensaje !== "") {
                setMensajeAlert(mensaje);
                setColor("warning");
                setAVisible(true);
                setisDisabled(false);
                setCargando(false);
                window.scrollTo(0, 0);
                return

            } else {
                setMensajeAlert("Sin mensaje");
                var pConcurrencia = false;
                var facturaGEN = {};
                setMensajeAlert("Antes de editar");
                const facturagenID = facturaEditando.id;
                if (editar) {
                    if (facturagenID) {
                        setMensajeAlert("Editando");
                        //Se obtienen los datos del embarque por id para revisa la concurrencia
                        facturaGEN = await GetFacturaConceptoGeneralID(facturagenID);
                        setMensajeAlert("Datos de factura; " + JSON.stringify(facturaGEN));
                        if (!facturaGEN.id) {
                            pConcurrencia = true;
                        } else {
                            if (facturaGEN.updatedAt !== facturaEditando.updatedAt) {
                                pConcurrencia = true;
                                mensaje = "Operación denegada; concurrencia en los datos generales del embarque";
                            }
                        }
                    } else {
                        mensaje = "Operación denegada; no se encontraron datos de la factura relacionada, favor de comunicarse a sistemas";
                        setMensajeAlert(mensaje);
                    }
                }
                setMensajeAlert("Sin mensaje 2; " + mensaje);
                //Se revisa si hay mensaje de error, si es así, se termina la transacción.
                if (mensaje !== "") {
                    setMensajeAlert(mensaje);
                    setColor("warning");
                    setAVisible(true);
                    setisDisabled(false);
                    setCargando(false);
                    window.scrollTo(0, 0);
                    return;
                }
                if (pConcurrencia === false) {
                    //Se empieza a realizar el registro de facturación

                    var numeroUP = 1;
                    var pConcurrencia = false;
                    //setMensajeAlert("Inicial " + editar);
                    if (!editar) {
                        //setMensajeAlert("No editar");
                        //Se obtienen los datos de los últimos números registrados en facturacionGen
                        const apiData = await API.graphql({
                            query: listEmbarqueUltimoNumeros,
                            variables: { limit: 100000000 },
                        });
                        const ultimapFromAPI = apiData.data.listEmbarqueUltimoNumeros.items;
                        //Si ya existen datos en la tabla listEmbarqueUltimoNumeros
                        if (!ultimapFromAPI.length) {
                            //setMensajeAlert("Error al guardar número de embarque ");
                            await API.graphql({
                                query: createEmbarqueUltimoNumero,
                                variables: {
                                    input: {
                                        numeroFacturaGeneral: numeroUP,
                                        activo: true,
                                        Reg_Ins_Usuario: userName,
                                    },
                                },
                            });
                        } else {
                            //Se actualizan los datos en EmbarqueUltimoNumero,
                            await Promise.all(
                                ultimapFromAPI.map(async (ultimaEmbarque) => {
                                    if (!editar) {
                                        //Se determina el último número dependiendo el cliente
                                        numeroUP = ((ultimaEmbarque.numeroFacturaGeneral ? ultimaEmbarque.numeroFacturaGeneral : 0) + 1);
                                        ultimaEmbarque.numeroFacturaGeneral = numeroUP;
                                    }
                                    delete ultimaEmbarque.createdAt;
                                    delete ultimaEmbarque.updatedAt;
                                    delete ultimaEmbarque.__typename;
                                    ultimaEmbarque.Reg_Mod_Usuario = userName;
                                    //setMensajeAlert("Error al acualizar número de embarque ");
                                    await API.graphql({
                                        query: updateEmbarqueUltimoNumero,
                                        variables: { input: ultimaEmbarque },
                                    });

                                    return ultimaEmbarque;
                                })
                            );
                        }
                        //Se actualizan los datos de FacturaConceptoGeneral       
                        setMensajeAlert("Error al intentar obtener datos de la factura para editar");

                        var formData = {}
                        formData.numero = numeroUP
                        formData.fechaDeFacturacion = fechaFactura;
                        formData.clienteID = clienteID;
                        formData.cliente = cliente;
                        formData.billTo = billTo;
                        formData.shipTo = shipTo
                        formData.salesPerson = salesPerson;
                        formData.PO = poNumber;
                        formData.requisitioner = requisitioner;
                        formData.facturaDescuentoP = facturaDescuentoP;
                        formData.comentariosFacturacion = comentariosFacturacion;
                        formData.casQuote = "BTIMF111319-001A";
                        formData.shippedvia = "EMAIL";
                        formData.Conceptos = inputListServicios;
                        formData.dueDate = dueDate;
                        formData.invoiceID = "BTI-" + aLetrar + mNumero + "-" + aLetra + formData.numero;
                        formData.activo = true;
                        formData.Reg_Ins_Usuario = userName;

                        setMensajeAlert(
                            "Error al intentar guardar los datos de la factura " + JSON.stringify(formData)
                        );
                        await API.graphql({
                            query: createFacturaConceptoGeneral,
                            variables: { input: formData },
                        });


                    } else {
                        //Se actualizan los datos de la tabla FacturaConceptoGeneral
                        var formData = await GetFacturaConceptoGeneralID(facturagenID);
                        formData.fechaDeFacturacion = fechaFactura;
                        formData.clienteID = clienteID;
                        formData.cliente = cliente;
                        formData.billTo = billTo;
                        formData.shipTo = shipTo
                        formData.salesPerson = salesPerson;
                        formData.PO = poNumber;
                        formData.requisitioner = requisitioner;
                        formData.facturaDescuentoP = facturaDescuentoP;
                        formData.comentariosFacturacion = comentariosFacturacion;
                        formData.casQuote = "BTIMF111319-001A";
                        formData.shippedvia = "EMAIL";
                        formData.Conceptos = inputListServicios;
                        formData.dueDate = dueDate;
                        formData.invoiceID = "BTI-" + aLetrar + mNumero + "-" + aLetra + formData.numero;
                        //"BTI-" + aLetra + formData.numero;
                        formData.Reg_Mod_Usuario = userName;
                        delete formData.createdAt;
                        delete formData.updatedAt;
                        delete formData.__typename;
                        setMensajeAlert(
                            "Error al intentar guardar los datos del embarque "
                        );
                        await API.graphql({
                            query: updateFacturaConceptoGeneral,
                            variables: { input: formData },
                        });


                    }
                    setMensajeAlert("Operación exitosa ");
                    setisDisabled(false);
                    setColor("primary");
                    setAVisible(true);
                    setCargando(true);
                    fetchFacturas(rfechaini, rfechafin);
                    updateFormState(() => ({ ...formState, formType: "FacturaciónGeneral" }));
                    setInputListServicios([]);
                    setFechaFactura("");
                    setRequisitioner("");
                    setFacturaDescuentoP("");
                    setPoNumber("");
                    setSalesPerson("");
                    setComentariosFacturacion("");
                    setDueDate("");
                    setInvoiceID("");
                    setShipTo("");
                    setBillTo("");
                    setClienteID("");
                    setCliente("");
                    setCargando(false);
                } else {
                    //Si la fecha es diferente significa que sí hay concurrencia y que se tienen que actualizar los datos
                    window.scrollTo(0, 0);
                    setMensajeAlert(
                        "No fue posible realizar la operación: existe concurrencia, se requiere cancelar la operación y " +
                        " volver a intentarlo"
                    );
                    setColor("warning");
                    setCargando(false);
                    setAVisible(true);
                    setisDisabled(false);
                    fetchFacturas(rfechaini, rfechafin);
                }
            }
        } catch (e) {
            window.scrollTo(0, 0);
            //setMensajeAlert(e.message);
            //"No fue posible terminar la operación: revise si la operación se realizó parcialmente, revise su conexión a internet y vuelva a intentar, si el problema persiste, favor de comunicarte a sistemas"
            setColor("warning");
            setAVisible(true);
            setCargando(false);
            setisDisabled(false);
        }
    }
    return (
        (pfacturacion === true) && (
            <>
                <div className="conteiner2">
                    <Alert color={color} isOpen={aVisible} toggle={onDismiss}>
                        {mensajeAlert}
                    </Alert>
                    {cargando === true && (
                        <Row>
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 " >
                                <img width="150px" alt="cargando" src="assets/img/preloader.gif" />
                            </div>
                        </Row>
                    )}
                    {formType === "FacturaciónGeneral" && (
                        <>
                            <Row>
                                <div class="col-lg-1 col-md-1 col-sm-2 col-xs-2 text-rigth  margintop60px" >
                                    <Label className={"floatrightleft"}><h5>Fecha: </h5></Label>
                                </div>
                                <div class="col-lg-2 col-md-6 col-sm-10 col-xs-10 text-left  margintop60px" >
                                    <FormGroup >
                                        <div class="input-group mb-3">
                                            <div class="input-group-prepend">
                                                <div class="input-group-text">
                                                    <input type="checkbox" checked={buscarporFecha} onChange={clicBuscarporFecha} />
                                                </div>
                                            </div>
                                            <input type="date" class="form-control" onChange={onSearchFechaFacturaGEN} value={fechaPBusqueda} disabled={!buscarporFecha} />
                                        </div>
                                    </FormGroup>
                                </div>
                                <div className="col-lg-3 col-md-12 col-sm-12 col-xs-12 margintop10px" ></div>
                                <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12 margintop10px" >
                                    {/*pfacturacion === true && (<button className="cbutton btn-success floatright  ml-2 margintopmobil10px marginrightmobil3p " title="Tomar como base planeación" onClick={() => { clicPlaneacionBase(); }}> <span className="fa fa-plus"></span>Base</button>)*/}
                                    {pfacturacion === true && (<button className="cbutton btn-success floatright  ml-2 margintopmobil10px marginrightmobil3p " title="Agregar nueva factura general" onClick={() => { clicNuevaFacturaGEN(); }}> <span className="fa fa-plus"> </span>Nueva</button>)}
                                    <div className=" form-group row col-lg-12 col-md-12 col-sm-12 col-xs-12  floatrightleft ml-1">
                                        <div className="  col-lg-2 col-md-2 col-sm-12 col-xs-12  ml-3"></div>
                                        <div className=" form-group row col-lg-5 col-md-5 col-sm-12 col-xs-12   margintop10px   ml-1 ">
                                            <InputGroup>
                                                <InputGroupAddon addonType="prepend">
                                                    <InputGroupText>Del:</InputGroupText>
                                                </InputGroupAddon>
                                                <Input name="Irfechaini" type="date" value={Moment(rfechaini).format("YYYY-MM-DD")} onChange={onChangesRFechaFGEN} />
                                            </InputGroup>
                                        </div>
                                        <div className=" form-group row col-lg-5 col-md-5 col-sm-12 col-xs-12   margintop10px  floatrightleft ml-1 ">
                                            <InputGroup className="floatrightleft ml-1">
                                                <InputGroupAddon addonType="prepend">
                                                    <InputGroupText>Al:</InputGroupText>
                                                </InputGroupAddon>
                                                <Input name="Irfechafin" type="date" value={Moment(rfechafin).format("YYYY-MM-DD")} onChange={onChangesRFechaFGEN} />
                                            </InputGroup>
                                        </div>
                                    </div>
                                </div>
                            </Row>
                            <Row >
                                <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                                    <button
                                        className="cbutton btn-dark floatright   marginrightmobil3p "
                                        title="Recargar página"
                                        onClick={() => { fetchFacturas(rfechaini, rfechafin); }}>
                                        <IoIcons.IoMdRefresh /> Recargar
                                    </button>
                                </div>
                                <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll">
                                    <Table className="mb-2 scroll ">
                                        <Thead class="thead-secondary">
                                            <Tr>
                                                <Th className="minwidth80px">Invoice ID</Th>
                                                <Th className="minwidth200px">Client</Th>
                                                <Th className="minwidth200px">PO</Th>
                                                <Th>Requisitioner</Th>
                                                <Th className="minwidth80px">Date</Th>
                                                <Th>DueDate</Th>
                                                <Th>Discount</Th>
                                                <Th>Coments</Th>
                                                <Th className="minwidth80px">Acciones</Th>
                                            </Tr>
                                        </Thead>
                                        <Tbody>
                                            {facturados.map((facturacg, i) => (
                                                <Tr className={i % 2 !== 0 ? "table-active" : ""}>
                                                    <Td>{facturacg.invoiceID}</Td>
                                                    <Td>{facturacg.cliente}</Td>
                                                    <Td>{facturacg.PO}</Td>
                                                    <Td>{facturacg.requisitioner}</Td>
                                                    <Td>{facturacg.fechaDeFacturacion}</Td>
                                                    <Td>{facturacg.dueDate}</Td>
                                                    <Td>{facturacg.facturaDescuentoP}</Td>
                                                    <Td className={facturacg.facturaDescuentoP ? "" : "margintopmobil20px"}>{facturacg.comentariosFacturacion}</Td>
                                                    <Td className={facturacg.comentariosFacturacion ? "" : "margintopmobil20px"}>
                                                        <button
                                                            class="btn-info cbutton mt-1 ml-1"
                                                            onClick={() => clicMostrar(facturacg)}
                                                            title="Detalles del embarque"
                                                        >
                                                            <IoIcons.IoIosListBox />{" "}
                                                        </button>
                                                        {pfacturacion && (
                                                            <>
                                                                <button
                                                                    class="btn-primary cbutton mt-1 ml-1"
                                                                    onClick={() => clicEditar(facturacg, i)}
                                                                    title="Editar"
                                                                >
                                                                    {" "}
                                                                    <IoIcons.IoIosCreate />{" "}
                                                                </button>
                                                                <button
                                                                    class="btn-warning cbutton mt-1 ml-1"
                                                                    title="Invoice"
                                                                    onMouseDown={"() => setIndexImp(0)"}
                                                                    onClick={() => clicImprimir(facturacg)}
                                                                >

                                                                    <IoIcons.IoIosPrint />{" "}
                                                                </button>
                                                                <button
                                                                    class="btn-dark cbutton mt-1 ml-1"
                                                                    title="Servicios extra"
                                                                    onMouseDown={"() => setIndexImp(1)"}
                                                                    onClick={"() => clicImprimir(facturacg)"}
                                                                    hidden={facturacg.serviciosExtra ? facturacg.serviciosExtra.length > 0 ? false : true : true}
                                                                >
                                                                    <IoIcons.IoIosPrint />
                                                                </button>
                                                                {/**<button class="btn-danger cbutton mt-1 ml-1" onClick={() => clicEliminar(facturacg)} title="Eliminar"> <IoIcons.IoIosClose /> </button> */}
                                                            </>
                                                        )}
                                                    </Td>
                                                </Tr>
                                            ))}
                                        </Tbody>
                                    </Table>
                                </div>
                            </Row>
                            <div className="mt-3 mb-3">
                                Página {currentPage}, mostrando del{" "}
                                {recordPerPage * currentPage - recordPerPage + 1} al{" "}
                                {facturasSinFiltro.length < recordPerPage * currentPage
                                    ? facturasSinFiltro.length
                                    : recordPerPage * currentPage}{" "}
                                de {facturasSinFiltro.length} registros
                            </div>
                            <div class="col-lg-12 col-md-12 col-sm-12  ">
                                <div class="floatcenter">
                                    <ul class="pagination">
                                        <li class={currentPageFacturacion === 1 ? "page-item disabled" : "page-item"}>
                                            <a class="page-link" href="#" aria-label="Go to first page" onClick={() => handlePageChangeFacturacion(1)}>«</a>
                                        </li>
                                        <li class={currentPageFacturacion === 1 ? "page-item disabled" : "page-item"}>
                                            <a class="page-link" href="#" aria-label="Go to previous page" onClick={() => handlePageChangeFacturacion(currentPageFacturacion - 1)}>⟨</a>
                                        </li>
                                        {paginas.map(pagina => (
                                            ((pagina.pagina < currentPageFacturacion + pageRange) && (pagina.pagina >= ((paginas.length - (pageRange - 1)) <
                                                ((currentPageFacturacion + pageRange) - pageRange) ? (paginas.length - (pageRange - 1)) : ((currentPageFacturacion + pageRange) - pageRange)))) && (
                                                <li class={currentPageFacturacion === pagina.pagina ? "page-item active" : "page-item "}>
                                                    <a class="page-link " onClick={() => handlePageChangeFacturacion(pagina.pagina)}>{pagina.pagina}</a>
                                                </li>
                                            )
                                        ))}
                                        <li class={currentPageFacturacion === ultimoNumeroP ? "page-item disabled" : "page-item"}>
                                            <a class="page-link" href="#" aria-label="Go to next page" onClick={() => handlePageChangeFacturacion(currentPageFacturacion + 1)}>⟩</a>
                                        </li>
                                        <li class={currentPageFacturacion === ultimoNumeroP ? "page-item disabled" : "page-item"}>
                                            <a class="page-link" href="#" aria-label="Go to last page" onClick={() => handlePageChangeFacturacion(ultimoNumeroP)}>»</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            {/*<div className="col-lg-5 col-md-5 col-sm-12 col-xs-12 text-left scroll" style={{ marginTop: 20 }}>{JSON.stringify(planeacionSinFiltro)}</div>*/}
                            {/*Imprimir */}
                            <div className='displaynone'>
                                <div ref={componentRef}>
                                    <Row>
                                        <img
                                            className="imgmarlimpf"
                                            src="assets/img/Logo/logost.png"
                                        />
                                        <div class="col-lg-6 col-md-6 col-sm-6  col-xs-6 margintop20px   textaligmentcenter">
                                            <h5 class="floatright fontsizeN20px">
                                                Boon tec International S de RL de CV
                                            </h5>
                                            <h5 class=" floatright fontsize20px ">
                                                We keep your chain going, any day, any time"
                                            </h5>
                                        </div>
                                        <div class="col-lg-6 col-md-6 col-sm-6  col-xs-6 margintop20px   textaligmentcenter">
                                            <h5 class="floatright fontsize25Bpx mr-3">
                                                INVOICE
                                            </h5>
                                        </div>
                                        <div class="col-lg-6 col-md-6 col-sm-6  col-xs-6 margintop20px   textaligmenleft">
                                            <h5 class=" fontsizeN20px ml-3">
                                                Boon Tec International
                                            </h5>
                                            <h5 class=" fontsizeN20px margintop-6px ml-3 ">
                                                7728 Padre Island Hwy
                                            </h5>
                                            <h5 class=" fontsizeN20px margintop-6px ml-3">
                                                Brownsville Texas 78521
                                            </h5>
                                            <h5 class="fontsizeN20px margintop-6px ml-3">
                                                Phone: 956 656 0481
                                            </h5>
                                            <h5 class="fontsizeN20px margintop-6px ml-3">
                                                TAX ID: BTI180403MA2
                                            </h5>
                                        </div>
                                        <div class="col-lg-6 col-md-6 col-sm-6  col-xs-6 margintop20px   textaligmenright">
                                            <h5 class="margintop-6px mr-3">
                                                Invoice #: {invoiceID}
                                            </h5>
                                            <h5 class="margintop-6px mr-3">
                                                Date:  {Moment(fechaFactura).format("MMMM DD, YYYY")}
                                            </h5>
                                        </div>
                                        <div class="col-lg-4 col-md-4 col-sm-4  col-xs-4 margintop20px fontsizeN20px  textaligmenleft">
                                            <h5 class="  ml-3 fontsizeN20px ">
                                                Bill To:
                                            </h5>
                                            <h5 class="margintop-6px ml-3 fontsizeN20px">
                                                {billTo}
                                            </h5>
                                        </div>
                                        <div class="col-lg-4 col-md-4 col-sm-4  col-xs-4 margintop20px fontsizeN20px  textaligmenleft">
                                            <h5 class=" ml-3 fontsizeN20px ">
                                                Ship To:
                                            </h5>
                                            <h5 class="margintop-6px ml-3 fontsizeN20px">
                                                {shipTo}
                                            </h5>
                                        </div>
                                        <div class="col-lg-4 col-md-4 col-sm-4  col-xs-4 margintop20px   textaligmenleft"></div>
                                        <div class="col-lg-6 col-md-6 col-sm-6  col-xs-6   fontsize20px textaligmenleft">
                                            <h5 class="  ml-3 margintop20px">
                                                Comments or special instructions :
                                            </h5>
                                        </div>
                                        <div class="col-lg-12 col-md-12 col-sm-12  col-xs-12 margintop20px   textaligmenleft ml-3">
                                            <h5 class="margintop-6px floatleft">
                                                _____________________________________________________________________________________________________________________________________________
                                            </h5>
                                            <h5 class="margintop-6px floatleft">
                                                _____________________________________________________________________________________________________________________________________________
                                            </h5>
                                            <h5 class="margintop-6px floatleft">
                                                _____________________________________________________________________________________________________________________________________________
                                            </h5>
                                        </div>
                                        <div class="col-lg-12 col-md-12 col-sm-12  col-xs-12 margintop-92px   textaligmenleft ml-3">
                                            <h5 class=" floatleft">
                                                {comentariosFacturacion}
                                            </h5>

                                        </div>
                                    </Row>
                                    <div>
                                        <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                                            <Table
                                                bordered
                                                className="margintop20px mb-2  fontsize20px "
                                            >
                                                <Thead>
                                                    <Tr>
                                                        <Th className="thtableImprimir  fontsize20px textaligmentcenter">
                                                            SALESPERSON
                                                        </Th>
                                                        <Th className="minwidth200px thtableImprimir fontsize20px textaligmentcenter">
                                                            SUPPLIER P.O. NUMBER
                                                        </Th>
                                                        {/*<Th className="minwidth200px thtableImprimir fontsize20px textaligmentcenter">Lote</Th>*/}
                                                        <Th className="thtableImprimir fontsize20px textaligmentcenter">
                                                            REQUISITIONER
                                                        </Th>
                                                        <Th className="minwidth200px thtableImprimir fontsize20px textaligmentcenter">
                                                            SHIPPED VIA
                                                        </Th>
                                                        <Th className="minwidth60px thtableImprimir fontsize20px textaligmentcenter">
                                                            DUE DATE
                                                        </Th>
                                                        <Th className="thtableImprimir fontsize20px textaligmentcenter">
                                                            CAS Quote #
                                                        </Th>
                                                    </Tr>
                                                </Thead>
                                                <Tbody>

                                                    <Tr>
                                                        <Td className="fontsize20px textaligmentcenter">
                                                            {salesPerson}
                                                        </Td>
                                                        <Td className="fontsize20px textaligmentcenter">
                                                            {poNumber}
                                                        </Td>
                                                        {/*<Td className="fontsize20px textaligmentcenter">{facturasgen.lote}</Td>*/}
                                                        <Td className="fontsize20px textaligmentcenter">
                                                            {requisitioner}
                                                        </Td>
                                                        <Td className="fontsize20px textaligmentcenter">
                                                            Email
                                                        </Td>
                                                        <Td className={"fontsize20px textaligmentcenter"}>
                                                            {Moment(dueDate).format("MMMM DD, YYYY")}
                                                        </Td>
                                                        <Td className="fontsize20px textaligmentcenter">
                                                            {casQuote}
                                                        </Td>
                                                    </Tr>

                                                </Tbody>
                                            </Table>


                                        </div>
                                        <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                                            <Table
                                                bordered
                                                className="margintop20px mb-2  fontsize20px "
                                            >
                                                <Thead>
                                                    <Tr>
                                                        <Th className="thtableImprimir  fontsize20px textaligmentcenter">
                                                            Quantity
                                                        </Th>
                                                        <Th className="minwidth200px thtableImprimir fontsize20px textaligmentcenter">
                                                            Description
                                                        </Th>
                                                        <Th className="thtableImprimir fontsize20px textaligmentcenter">
                                                            Unit price (U$D)
                                                        </Th>
                                                        <Th className="thtableImprimir fontsize20px textaligmentcenter">
                                                            Discount
                                                        </Th>
                                                        <Th className="thtableImprimir fontsize20px textaligmentcenter">
                                                            Total
                                                        </Th>

                                                    </Tr>
                                                </Thead>
                                                <Tbody>
                                                    {inputListServicios.map(
                                                        (facturasgen, i) =>
                                                            i < 28 && (
                                                                <Tr>
                                                                    <Td className="fontsize20px textaligmentcenter">
                                                                        {facturasgen.quantity}
                                                                    </Td>
                                                                    <Td className="fontsize20px textaligmentcenter">
                                                                        {facturasgen.description}
                                                                    </Td>
                                                                    <Td className="fontsize20px textaligmentcenter">
                                                                        {"$" + facturasgen.uprice}
                                                                    </Td>
                                                                    <Td className="fontsize20px textaligmentcenter">
                                                                        {"$" + facturasgen.discount}
                                                                    </Td>
                                                                    <Td className="fontsize20px textaligmentcenter">
                                                                        {"$" + facturasgen.subTotal}
                                                                    </Td>
                                                                </Tr>
                                                            )
                                                    )}
                                                </Tbody>
                                            </Table>

                                            {inputListServicios.length > 33 && (
                                                <>
                                                    <div className="page-break">
                                                        <Table
                                                            bordered
                                                            className=" mb-2  fontsize20px "
                                                        >
                                                            <Thead>
                                                                <Tr>
                                                                    <Th className="thtableImprimir  fontsize20px textaligmentcenter">
                                                                        Quantity
                                                                    </Th>
                                                                    <Th className="minwidth200px thtableImprimir fontsize20px textaligmentcenter">
                                                                        Description
                                                                    </Th>
                                                                    <Th className="thtableImprimir fontsize20px textaligmentcenter">
                                                                        Unit price (U$D)
                                                                    </Th>
                                                                    <Th className="thtableImprimir fontsize20px textaligmentcenter">
                                                                        Discount
                                                                    </Th>
                                                                    <Th className="thtableImprimir fontsize20px textaligmentcenter">
                                                                        Total
                                                                    </Th>
                                                                </Tr>
                                                            </Thead>
                                                            <Tbody>
                                                                {inputListServicios.map(
                                                                    (facturasgen, i) =>
                                                                        i > 33 && (
                                                                            <Tr>
                                                                                <Td className="fontsize20px textaligmentcenter">
                                                                                    {facturasgen.quantity}
                                                                                </Td>
                                                                                <Td className="fontsize20px textaligmentcenter">
                                                                                    {facturasgen.description}
                                                                                </Td>
                                                                                <Td className="fontsize20px textaligmentcenter">
                                                                                    {"$" + facturasgen.uprice}
                                                                                </Td>
                                                                                <Td className="fontsize20px textaligmentcenter">
                                                                                    {"$" + facturasgen.discount}
                                                                                </Td>
                                                                                <Td className="fontsize20px textaligmentcenter">
                                                                                    {"$" + facturasgen.subTotal}
                                                                                </Td>
                                                                            </Tr>
                                                                        )
                                                                )}
                                                            </Tbody>
                                                        </Table>
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                        <Row>
                                            <div class="col-lg-12 col-md-12 col-sm-12 mb-1   ">
                                                <h5 class="floatright mr-3">
                                                    SUB-TOTAL: ${sumSubTotalServicio}
                                                </h5>
                                            </div>
                                        </Row>
                                        <Row>
                                            <div class="col-lg-12 col-md-12 col-sm-12 mb-1">
                                                <h5 class="floatright mr-3">
                                                    {(facturaDescuentoP ? facturaDescuentoP : "") + "% OFF: " +
                                                        "$" + sumTotalDesServicio}
                                                </h5>
                                            </div>
                                        </Row>
                                        <Row></Row>
                                        <div class="col-lg-12 col-md-12 col-sm-12 mb-1   ">
                                            <h5 class="floatright ">
                                                Total due: ${sumTotalServicio}
                                            </h5>
                                        </div>
                                        <div class="col-lg-12 col-md-12 col-sm-12 margintop100px ">
                                            <p class="textaligmentcenter fontsize18px">
                                                A CUSTOMER SATISFACTION SURVEY SHALL BE SEND TO OUR CUSTOMER AT INVOICING
                                            </p>
                                            <p class="textaligmencenter fontsize18px margintop-6px">
                                                A COMPLETED CUSTOMER SATISFACTION SURVEY SHOULD BE ON FILE AT LEAST QUATERLY FOR RECENT CUSTOMERS/ SERVICES
                                            </p>
                                        </div>
                                        <div class="col-lg-12 col-md-12 col-sm-12 margintop100px ">
                                            <h5 class="textaligmentleft fontsizeN20px">
                                                Payment Method:
                                            </h5>
                                            <h5 class="textaligmentleft fontsizeN20px margintop-6px">
                                                Please make a check to:
                                            </h5>
                                        </div>
                                        <div class="col-lg-12 col-md-12 col-sm-12 margintop100px ">
                                            <h5 class="textaligmentleft fontsizeN20px">
                                                Mailling Address:
                                            </h5>
                                            <h5 class="textaligmentleft fontsize20px margintop-6px">
                                                Magdaleno Flores
                                            </h5>
                                            <h5 class="textaligmentleft fontsize20px margintop-6px">
                                                7728 Padre Island Highway
                                            </h5>
                                            <h5 class="textaligmentleft fontsize20px margintop-6px">
                                                Brownsville Texas 78521
                                            </h5>
                                            <h5 class="textaligmentleft fontsize20px margintop-6px">
                                                PH 512 686 1707
                                            </h5>
                                        </div>
                                        <div className="page-break">
                                            <Row>
                                                <div class="col-lg-12 col-md-12 col-sm-12 mt-2 ">
                                                    <h5>
                                                        <h5 class="textaligmentcenter fontsizeN30px margintop20px">Customer Satisfaction Survey </h5>
                                                        <h5 class="textaligmentcenter fontsize20px margintop30px">AS OUR VALUED CUSTOMER, Containment Assistance & Services de Mexico appreciates your</h5>
                                                        <h5 class="textaligmentcenter fontsize20px">business and will make any effort to improve the ability to provide a Continuously Improved Service to</h5>
                                                        <h5 class="textaligmentcenter fontsize20px">Your organization</h5>
                                                        <h5 class="textaligmentcenter fontsize20px">On that effort we require you take time to help us sharing your inputs about our Service by</h5>
                                                        <h5 class="textaligmentcenter fontsize20px">completing this Short Survey, so that we can implement appropriate measures to improve our</h5>
                                                        <h5 class="textaligmentcenter fontsize20px">performance and methods.</h5>
                                                        <h5 class="textaligmentcenter fontsize20px">Thank you in Advance !!!</h5>
                                                        <h5 class="textaligmentcenter fontsize20px">Boon Tec International S de RL de CV, Sales and Customer Care</h5>
                                                        <h5 class="textaligmentleft margintop30px fontsize20px">1.- On your perception, How was the Service performed in general?</h5>
                                                        <h5 class="textaligmentleft margintop20px  fontsize20px">
                                                            <span class="dot"></span> &nbsp; Extremely &nbsp; &nbsp; &nbsp; &nbsp;
                                                            <span class="dot"></span> &nbsp; OK &nbsp; &nbsp; &nbsp; &nbsp;
                                                            <span class="dot"></span> &nbsp; Very Well &nbsp; &nbsp; &nbsp; &nbsp;
                                                            <span class="dot"></span> &nbsp; Well &nbsp; &nbsp; &nbsp; &nbsp;
                                                            <span class="dot"></span> &nbsp; Just Aceptable &nbsp; &nbsp; &nbsp; &nbsp;
                                                            <span class="dot"></span> &nbsp; Non OK
                                                        </h5>
                                                        <h5 class="textaligmentleft margintop30px  fontsize20px">2.- Have the Orders/Materials been provided in a "On time Delivery"?</h5>
                                                        <h5 class="textaligmentleft margintop20px  fontsize20px">
                                                            <span class="dot"></span> &nbsp; Extremely &nbsp; &nbsp; &nbsp; &nbsp;
                                                            <span class="dot"></span> &nbsp; OK &nbsp; &nbsp; &nbsp; &nbsp;
                                                            <span class="dot"></span> &nbsp; Very Well &nbsp; &nbsp; &nbsp; &nbsp;
                                                            <span class="dot"></span> &nbsp; Well &nbsp; &nbsp; &nbsp; &nbsp;
                                                            <span class="dot"></span> &nbsp; Just Aceptable &nbsp; &nbsp; &nbsp; &nbsp;
                                                            <span class="dot"></span> &nbsp; Non OK
                                                        </h5>
                                                        <h5 class="textaligmentleft margintop30px  fontsize20px">3.- Is BTI your first option for ecoat your parts next time?</h5>
                                                        <h5 class="textaligmentleft margintop20px  fontsize20px">
                                                            <span class="dot"></span> &nbsp; Yes &nbsp; &nbsp; &nbsp; &nbsp;
                                                            <span class="dot"></span> &nbsp; No, but I will if..____________________________________________________________________________________________________________
                                                        </h5>
                                                        <h5 class="margintop10px floatleft">
                                                            ______________________________________________________________________________________________________________________________________________
                                                        </h5>
                                                        <h5 class="textaligmentleft margintop30px  fontsize20px">4.- Is the Cost per part competitive compared with other options?</h5>
                                                        <h5 class="textaligmentleft margintop20px  fontsize20px">
                                                            <span class="dot"></span> &nbsp; Extremely &nbsp; &nbsp; &nbsp; &nbsp;
                                                            <span class="dot"></span> &nbsp; OK &nbsp; &nbsp; &nbsp; &nbsp;
                                                            <span class="dot"></span> &nbsp; Very Well &nbsp; &nbsp; &nbsp; &nbsp;
                                                            <span class="dot"></span> &nbsp; Well &nbsp; &nbsp; &nbsp; &nbsp;
                                                            <span class="dot"></span> &nbsp; Just Aceptable &nbsp; &nbsp; &nbsp; &nbsp;
                                                            <span class="dot"></span> &nbsp; Non OK
                                                        </h5>
                                                        <h5 class="textaligmentleft margintop30px  fontsize20px">5.- Was the quote clear, accurate and well documented including in time delivery?</h5>
                                                        <h5 class="textaligmentleft margintop20px  fontsize20px">
                                                            <span class="dot"></span> &nbsp; Extremely &nbsp; &nbsp; &nbsp; &nbsp;
                                                            <span class="dot"></span> &nbsp; OK &nbsp; &nbsp; &nbsp; &nbsp;
                                                            <span class="dot"></span> &nbsp; Very Well &nbsp; &nbsp; &nbsp; &nbsp;
                                                            <span class="dot"></span> &nbsp; Well &nbsp; &nbsp; &nbsp; &nbsp;
                                                            <span class="dot"></span> &nbsp; Just Aceptable &nbsp; &nbsp; &nbsp; &nbsp;
                                                            <span class="dot"></span> &nbsp; Non OK
                                                        </h5>
                                                        <h5 class="textaligmentleft margintop30px  fontsize20px">6.-  Is the Invoice Service accurate, fear and well documented?</h5>
                                                        <h5 class="textaligmentleft margintop20px  fontsize20px">
                                                            <span class="dot"></span> &nbsp; Extremely &nbsp; &nbsp; &nbsp; &nbsp;
                                                            <span class="dot"></span> &nbsp; OK &nbsp; &nbsp; &nbsp; &nbsp;
                                                            <span class="dot"></span> &nbsp; Very Well &nbsp; &nbsp; &nbsp; &nbsp;
                                                            <span class="dot"></span> &nbsp; Well &nbsp; &nbsp; &nbsp; &nbsp;
                                                            <span class="dot"></span> &nbsp; Just Aceptable &nbsp; &nbsp; &nbsp; &nbsp;
                                                            <span class="dot"></span> &nbsp; Non OK
                                                        </h5>
                                                    </h5>

                                                    <h5 class="margintop30px  fontsize20px textaligmentcenter">
                                                        Additional comments, or additional services are you interested from Boon Tec International S de RL de CV if any:
                                                    </h5>

                                                    <h5 class=" floatleft margintop20px">
                                                        _____________________________________________________________________________________________________________________________________________
                                                    </h5>
                                                    <h5 class="margintop10px floatleft">
                                                        _____________________________________________________________________________________________________________________________________________
                                                    </h5>
                                                    <h5 class="margintop10px floatleft">
                                                        _____________________________________________________________________________________________________________________________________________
                                                    </h5>
                                                </div>
                                            </Row>
                                            <Row>
                                                <div class="col-lg-12 col-md-12 col-sm-12 mt-5 ">
                                                    <h5 class="textaligmentleft   fontsize20px">
                                                        Customer Contact : ____________________________________________________________________________________
                                                    </h5>
                                                    <h5 class="textaligmentleft  margintop10px fontsize20px">
                                                        Company : _____________________________________________________________________________________________
                                                    </h5>
                                                    <h5 class="textaligmentleft  margintop10px fontsize20px">
                                                        Date : __________________________________________________________________________________________________
                                                    </h5>
                                                </div>
                                            </Row>
                                            <Row>
                                                <div class="col-lg-12 col-md-12 col-sm-12 mt-5 ">
                                                    <h5 class="textaligmentcenter  fontsize20px">
                                                        _______________________________________________________________
                                                    </h5>
                                                    <h5 class="textaligmentcenter  margintop-10px fontsize20px">
                                                        Signature
                                                    </h5>
                                                </div>
                                            </Row>
                                        </div>
                                    </div>
                                    <div class="footer">
                                        <p className="floatright margintop-16px mr-3">FOR-VE06 REV B</p> <br />
                                    </div>
                                </div>
                            </div>
                        </>

                    )}
                    {formType === "EditarFG" && (
                        <>
                            <Fragment>
                                {/*numeroP*/}
                                <Row>
                                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6  margintop20px " >
                                        <h5 className={"floatleft"}>{editar ? "Editando Invoice" + invoiceID : "Facturando conceptos generales"}</h5>
                                    </div>
                                </Row>
                                <Row>
                                    <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12   margintop20px ">
                                        <Label className={datosIncompletos === true && !fechaFactura ? "floatleft novalido" : "floatleft"}>
                                            Date* {/*clienteID*/}{" "}
                                        </Label>
                                        <Input
                                            name="fechaFactura"
                                            type="date"
                                            onChange={onChangesDatosFactura}
                                            value={fechaFactura}
                                        />
                                    </div>
                                    <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px ">
                                        <Label className={datosIncompletos === true && !cliente ? "floatleft novalido" : "floatleft"}>
                                            Cliente*{/*cliente*/}{" "}
                                        </Label>
                                        <select
                                            name="cliente"
                                            className="floatleft custom-select"
                                            onChange={onChangesClientes}
                                        >
                                            <option className="" value="">
                                                Elige un cliente{" "}
                                            </option>
                                            {clientes.map((cliente) => (
                                                <>
                                                    {cliente.activo && (
                                                        <option
                                                            className=""
                                                            value={cliente.id}
                                                            selected={
                                                                cliente === cliente.id ? true : false
                                                            }
                                                        >
                                                            {cliente.cliente}
                                                        </option>
                                                    )}
                                                </>
                                            ))}
                                        </select>
                                    </div>
                                    <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px ">
                                        <Label className={datosIncompletos === true && !requisitioner ? "floatleft novalido" : "floatleft"}>
                                            REQUISITIONER*
                                        </Label>
                                        <Input
                                            name="requisitioner"
                                            onChange={onChangesDatosFactura}
                                            value={requisitioner}
                                        />
                                    </div>
                                    <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px ">
                                        <Label className={datosIncompletos === true && !poNumber ? "floatleft novalido" : "floatleft"}>
                                            SUPPLIER P.O. NUMBER*
                                        </Label>
                                        <Input
                                            name="poNumber"
                                            onChange={onChangesDatosFactura}
                                            value={poNumber}
                                        />
                                    </div>
                                    <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px ">
                                        <Label className={datosIncompletos === true && !salesPerson ? "floatleft novalido" : "floatleft"}>
                                            SALES PERSON*
                                        </Label>
                                        <Input
                                            name="salesPerson"
                                            onChange={onChangesDatosFactura}
                                            value={salesPerson}
                                        />
                                    </div>
                                    <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px ">
                                        <Label className={datosIncompletos === true && !dueDate ? "floatleft novalido" : "floatleft"}>
                                            DUE DATE*
                                        </Label>
                                        <Input
                                            name="dueDate"
                                            type="date"
                                            onChange={onChangesDatosFactura}
                                            value={dueDate}
                                        />
                                    </div>
                                    <div class="col-lg-8 col-md-6 col-sm-12 col-xs-12 margintop20px ">
                                        <Label className="floatleft">
                                            Comments or special instructions
                                        </Label>
                                        <Input
                                            name="comentariosFacturacion"
                                            type="textarea"
                                            onChange={onChangesDatosFactura}
                                            value={comentariosFacturacion}
                                            rows="1"
                                        />
                                    </div>
                                    <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px ">
                                        <Label className={"floatleft"}>
                                            % Discount
                                        </Label>
                                        <Input
                                            name="facturaDescuentoP"
                                            type="text"
                                            onChange={(e) =>
                                                setInputListServicios(
                                                    handleInputChangePD(e, [
                                                        ...inputListServicios,
                                                    ])
                                                )
                                            }
                                            value={facturaDescuentoP}
                                        />
                                    </div>

                                    <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12 margintop20px ">
                                        <Label className={datosIncompletos === true && !shipTo ? "floatleft novalido" : "floatleft"}>
                                            Ship To*: {shipTo}
                                        </Label>
                                    </div>
                                    <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12 margintop20px ">
                                        <Label className={datosIncompletos === true && !billTo ? "floatleft novalido" : "floatleft"}>
                                            Bill To*: {billTo}
                                        </Label>
                                    </div>
                                </Row>

                                <Row>
                                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6  margintop20px " >
                                        <h5 className="floatleft">Detalle</h5>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 margintop20px " >
                                        <button className={" cbutton btn-success floatright "} color="success" size="sm" title="Agregar datos nuevos"
                                            onClick={(e) =>
                                                setInputListServicios(handleAddClick([...inputListServicios], { ...serviciosIniciales, createdAt: new Date() }))
                                            }> <span className="fa fa-plus"> Concepto</span> </button>
                                    </div>
                                </Row>
                                {inputListServicios.length > 0 && (
                                    <Row>
                                        <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12  scroll">
                                            <Table className=" mb-2  ">
                                                <Thead class="thead-secondary">
                                                    <Tr>
                                                        <Th>Quantity*</Th>
                                                        <Th className="">
                                                            Description*
                                                        </Th>
                                                        <Th className="">
                                                            Unit price*
                                                        </Th>
                                                        <Th className="">
                                                            Sub-Total
                                                        </Th>
                                                        <Th className="">
                                                            Discount
                                                        </Th>
                                                        <Th>Total* </Th>
                                                        <Th className=""> Eliminar </Th>
                                                    </Tr>
                                                </Thead>
                                                <Tbody>
                                                    {inputListServicios.map(
                                                        (x, i) =>
                                                            //x.activo && (
                                                            <Tr
                                                                className={
                                                                    i % 2 !== 0 ? "table-active" : ""
                                                                }
                                                            >
                                                                <Td className={datosIncompletos === true && !x.quantity ? "novalido" : ""}>
                                                                    <Input
                                                                        name="quantity"
                                                                        value={x.quantity ? x.quantity : ""
                                                                        }
                                                                        placeholder=""
                                                                        onChange={(e) =>
                                                                            setInputListServicios(
                                                                                handleInputChangeServicios(e, i, [
                                                                                    ...inputListServicios,
                                                                                ])
                                                                            )
                                                                        }
                                                                    />

                                                                </Td>
                                                                <Td className={datosIncompletos === true && !x.description ? "novalido" : ""}>
                                                                    <Input
                                                                        name="description"
                                                                        value={x.description ? x.description : ""
                                                                        }
                                                                        placeholder=""
                                                                        onChange={(e) =>
                                                                            setInputListServicios(
                                                                                handleInputChangeServicios(e, i, [
                                                                                    ...inputListServicios,
                                                                                ])
                                                                            )
                                                                        }
                                                                    />

                                                                </Td>
                                                                <Td className={datosIncompletos === true && !x.uprice ? "novalido" : ""}>
                                                                    <Input
                                                                        name="uprice"
                                                                        value={x.uprice ? x.uprice : ""
                                                                        }
                                                                        placeholder=""
                                                                        onChange={(e) =>
                                                                            setInputListServicios(
                                                                                handleInputChangeServicios(e, i, [
                                                                                    ...inputListServicios,
                                                                                ])
                                                                            )
                                                                        }
                                                                    />

                                                                </Td>
                                                                <Td className="">
                                                                    {x.subTotal ? "$" + x.subTotal : ""}
                                                                </Td>
                                                                <Td className="">
                                                                    {x.discount ? "$" + x.discount : ""}
                                                                </Td>
                                                                <Td className={x.discount ? "" : "margintopmobil20px"}>
                                                                    {x.total ? "$" + x.total : ""}
                                                                </Td>
                                                                {<Td className="margintopmobil20px">
                                                                    <Button
                                                                        className=" "
                                                                        title="Eliminar registro"
                                                                        size="sm"
                                                                        color="danger"
                                                                        onClick={() =>
                                                                            setInputListServicios(handleRemoveClick(i, [...inputListServicios,]))
                                                                        }
                                                                    >
                                                                        <IoIcons.IoMdClose />
                                                                    </Button>
                                                                </Td>}
                                                            </Tr>
                                                        // )
                                                    )}
                                                </Tbody>
                                            </Table>
                                        </div>
                                    </Row>
                                )}
                                <Row>
                                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 margintop20px">
                                        <Button
                                            className="floatright mr-3"
                                            onClick={cancelarFactura}
                                            color="danger"
                                        >
                                            Terminar
                                        </Button>

                                        <Button
                                            className="floatright"
                                            onClick={() => manageFacturacion()}
                                            disabled={inputListServicios.length > 0 ? false : true}
                                            color="primary"
                                        >
                                            {editar === true ? "Guardar Cambios" : "Generar Invoice"}
                                        </Button>
                                    </div>
                                </Row>
                                {/*<div className="col-lg-5 col-md-5 col-sm-12 col-xs-12 text-left scroll" style={{ marginTop: 20 }}>{JSON.stringify(recibaSinFiltro)}</div>*/}
                                {/*<div className="col-lg-5 col-md-5 col-sm-12 col-xs-12 text-left scroll" style={{ marginTop: 20 }}>{JSON.stringify(modificados)}</div>*/}
                            </Fragment>
                        </>
                    )}
                    {formType === "DetalleFG" && (
                        <>
                            <Fragment>
                                {/*numeroP*/}
                                <Row>
                                    <div className={"col-lg-6 col-md-6 col-sm-6 col-xs-6  margintop20px textaligmentleft"}>
                                        <h5>Datos generales Invoice {invoiceID}</h5>
                                    </div>
                                    <div className={"col-lg-6 col-md-6 col-sm-6 col-xs-6  margintop20px floatright"}>
                                        <button
                                            class="btn-info cbutton floatright "
                                            onClick={cancelarFactura}
                                            title="Regresar"
                                        >
                                            <IoIcons.IoMdArrowRoundBack />
                                            Regresar
                                        </button>
                                    </div>
                                </Row>


                                <Row>
                                    <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12  scroll">
                                        <Table className="margintop20px mb-2  ">
                                            <Thead class="thead-secondary">
                                                <Tr>
                                                    <Th>Invoice ID</Th>
                                                    <Th className="minwidth100px">Fecha</Th>
                                                    <Th className="minwidth100px">Cliente</Th>
                                                    <Th className="minwidth100px"> PO</Th>
                                                    <Th className="minwidth100px">Requisitioner</Th>
                                                    <Th className="minwidth100px">DueDate </Th>
                                                    <Th className="minwidth100px">Discount </Th>
                                                    <Th> Comentarios</Th>
                                                </Tr>
                                            </Thead>
                                            <Tbody>
                                                <Tr>
                                                    <Td>
                                                        {invoiceID}
                                                    </Td>
                                                    <Td>{fechaFactura}</Td>
                                                    <Td className=""> {cliente} </Td>
                                                    <Td className=""> {poNumber} </Td>
                                                    <Td className=""> {requisitioner} </Td>
                                                    <Td className="">{dueDate} </Td>
                                                    <Td className="">{facturaDescuentoP} </Td>
                                                    <Td className="">{comentariosFacturacion}</Td>
                                                </Tr>
                                            </Tbody>
                                        </Table>
                                    </div>
                                </Row>
                                {inputListServicios.length > 0 && (
                                    <Row>
                                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12  margintop20px " >
                                            <h5 className={"floatleft"}>Detalle de Factura</h5>
                                        </div>
                                        <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12  scroll">
                                            <Table className=" mb-2  ">
                                                <Thead class="thead-secondary">
                                                    <Tr>
                                                        <Th>Quantity</Th>
                                                        <Th className="">Description</Th>
                                                        <Th className=""> Unit price</Th>
                                                        <Th>Total</Th>
                                                    </Tr>
                                                </Thead>
                                                <Tbody>
                                                    {inputListServicios.map(
                                                        (x, i) =>
                                                            <Tr
                                                                className={
                                                                    i % 2 !== 0 ? "table-active" : ""
                                                                }
                                                            >
                                                                <Td>{x.quantity}</Td>
                                                                <Td >{x.description} </Td>
                                                                <Td >{ }</Td>
                                                                <Td >
                                                                    {x.total}
                                                                </Td>
                                                            </Tr>
                                                        // )
                                                    )}
                                                </Tbody>
                                            </Table>
                                        </div>
                                    </Row>
                                )}
                            </Fragment>
                        </>
                    )}
                </div>
            </>
        )
    )
};



export default FacturacionG